import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {TokenManagerService} from './token-login.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private tokenManagerService: TokenManagerService, private router: Router) {}

canActivate(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

  return this.tokenManagerService.isAuthenticated()
    .then(
      (authenticated: boolean) => {
    if (authenticated) {
      return true;
    } else {
      this.router.navigate(['Login']);
    }
  }
 );
 }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/services/auth-guard.service.ts